'use client';

import { IProductDetail } from '@/api/types/public';
import { colors, font } from '@/theme/zeelool.theme';
import { Box, Typography } from '@mui/material';

interface ShippingReturnProps {
  detail?: IProductDetail;
  variant?: 'default' | 'tab'; // 新增样式变体参数
}

interface FreightItem {
  title: string;
  content: string;
}

export default function ShippingReturn({ detail, variant = 'default' }: ShippingReturnProps) {
  // 检查数据是否存在
  if (!detail?.product_content_freight?.values?.length) {
    return null;
  }

  // 根据变体获取样式配置
  const getStyles = () => {
    if (variant === 'tab') {
      return {
        container: 'bg-[#f4f4f4] py-[3.75vw] px-[12.5vw] rounded-[4px] mt-[1.67vw]',
        wrapper: 'flex items-start justify-between',
        item: 'item w-[29vw]',
        title: 'font-bb text-16 leading-24 text-left text-20',
        content: 'mt-8 font-normal text-14 leading-[22px] text-left',
      };
    }

    return {
      container: 'bg-auxiliary-gray py-20 px-12 rounded-[2px]',
      wrapper: 'flex justify-between items-start flex-wrap',
      item: '',
      title: 'font-bb text-[14px] text-primary-text leading-[17px] text-left',
      content: '',
    };
  };

  const styles = getStyles();

  // 渲染单个项目
  const renderItem = (item: FreightItem, index: number) => {
    if (variant === 'tab') {
      return (
        <div key={index} className={styles.item}>
          <h4 className={styles.title}>{item.title}</h4>
          <div
            className={`${styles.content} goods-detail-shipping-return-content`}
            dangerouslySetInnerHTML={{
              __html: item.content || '',
            }}
          />
        </div>
      );
    }

    return (
      <Box
        key={item.title}
        sx={{
          mb: index === detail.product_content_freight.values.length - 1 ? 0 : 2,
        }}
      >
        <h4 className={styles.title}>{item.title}</h4>
        <Typography
          component="pre"
          dangerouslySetInnerHTML={{
            __html: item.content,
          }}
          sx={{
            fontFamily: font.ir,
            fontSize: '13px',
            lineHeight: '20px',
            whiteSpace: 'pre-wrap',
            mt: '8px',
            '& a': {
              color: colors.primaryPurple,
              cursor: 'pointer',
            },
            '& b': {
              fontFamily: font.bb,
            },
          }}
        />
      </Box>
    );
  };

  // 统一的渲染结构
  const ContainerComponent = variant === 'default' ? Box : 'div';
  const WrapperComponent = variant === 'default' ? Box : 'div';

  return (
    <ContainerComponent className={styles.container}>
      <WrapperComponent className={styles.wrapper}>
        {detail.product_content_freight.values.map((item: FreightItem, index: number) =>
          renderItem(item, index),
        )}
      </WrapperComponent>
    </ContainerComponent>
  );
}
